const KST_TIME_ZONE = 'Asia/Seoul';

function getFormattedDateParts(date) {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: KST_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  return formatter.formatToParts(date);
}

function getDatePart(parts, type) {
  return parts.find((part) => part.type === type)?.value || '';
}

export function getKstDateString(date = new Date()) {
  const parts = getFormattedDateParts(date);
  const year = getDatePart(parts, 'year');
  const month = getDatePart(parts, 'month');
  const day = getDatePart(parts, 'day');

  return `${year}-${month}-${day}`;
}

export function getFutureKstDateString(daysToAdd, baseDate = new Date()) {
  const futureDate = new Date(baseDate.getTime() + daysToAdd * 24 * 60 * 60 * 1000);
  return getKstDateString(futureDate);
}

export function cloneValue(value) {
  return JSON.parse(JSON.stringify(value));
}

export function buildUserInfoState(user, data = {}) {
  return {
    userId: user.uid,
    ...data,
    credit: data.credit ?? 20,
  };
}

export function createUserFormState({ isRegistered, userInfo }) {
  if (isRegistered && userInfo) {
    return {
      nickname: userInfo.nickname || '',
      affiliation: userInfo.affiliation || '',
      emailUpdatesConsent: userInfo.emailUpdatesConsent || false,
      termsAgreement: false,
      privacyPolicyAgreement: false,
    };
  }

  return {
    nickname: '',
    affiliation: '',
    emailUpdatesConsent: false,
    termsAgreement: false,
    privacyPolicyAgreement: false,
  };
}

export function buildSavedUserInfo({
  user,
  userInfo,
  nickname,
  affiliation,
  emailUpdatesConsent,
  isRegistered,
  termsAgreement,
  privacyPolicyAgreement,
}) {
  const updatedInfo = {
    ...(userInfo || {}),
    userId: user.uid,
    nickname,
    affiliation,
    email: user.email,
    emailUpdatesConsent,
  };

  if (!isRegistered) {
    updatedInfo.termsAgreement = Boolean(termsAgreement);
    updatedInfo.privacyPolicyAgreement = Boolean(privacyPolicyAgreement);
    updatedInfo.apiCallCount = 0;
    updatedInfo.signupDate = new Date();
    updatedInfo.credit = 20;
  }

  return updatedInfo;
}

export function createSignedOutState() {
  return {
    userSettings: {},
    userInfo: null,
    nickname: '',
    affiliation: '',
    emailUpdatesConsent: false,
    termsAgreement: false,
    privacyPolicyAgreement: false,
    showUserInfoForm: false,
    showSettings: false,
    isSettingsDirty: false,
    originalSettingsSnapshot: null,
    showStorePromptDialog: false,
    showCloseConfirmDialog: false,
    showCreditDialog: false,
    requiredCreditForDialog: 0,
    isRegistered: false,
    storedPrompts: [],
  };
}

export function shouldShowNoticeDialog({
  isInApp,
  dontShowUntil,
  today = getKstDateString(),
}) {
  if (isInApp) {
    return false;
  }

  return !dontShowUntil || today > dontShowUntil;
}
